import dayjs from 'dayjs';
import { useContext, useEffect, useState } from 'react';
import { useIsFetching } from 'react-query';
import { UserContext } from '../contexts/userContext';
import { useGetCuotas } from './cuotas';
import { useGetAlumnos } from './getAlumnos';
import { useGetGrupos } from './useGrupos';


export function useGetAlertas() {
  const { user } = useContext(UserContext);
  const cuotas = useGetCuotas(user);
  const grupos = useGetGrupos(user);
  const alumnos = useGetAlumnos(user);
  const [faltanCuotas, setFaltanCuotas] = useState<string[]>();
  useIsFetching(); //trigger rerender at query activity

  const currentYear = dayjs().year();
  const currentMonth = dayjs().month();
  const olderRecord = cuotas.data?.length ? cuotas.data.reduce((prev, curr) => {
    return (curr.ano < prev.ano) ? curr : prev;
  }).ano : dayjs().year();

  const listingYears:(number | never)[] = [];
  for (let year = olderRecord; year <= currentYear + 1; year++) listingYears.push(year);

  const checkMissingCuotas = () => {
    if (!cuotas.data || !grupos.data) return;
    const faltanCuotasArr:any = [];
    for (const grupo of grupos.data) {
      const cuotasGrupo = cuotas?.data?.filter((c) => c.grupo === grupo.nombre);
      const values:any = {};
      for (const y of listingYears) {
        values[y] = [];
        for (let mes = 1; mes <= 12; mes++) {
          const cuotaEncontrada = cuotasGrupo.find((c) => c.ano === y && c.mes === mes);
          if (cuotaEncontrada) values[y].push(cuotaEncontrada.montoEfectivo);
          else values[y].push(null);
        }
      }
      if (!values?.[currentYear][currentMonth]
          || !values?.[currentYear][dayjs().add(1, 'month').month()]) {
        faltanCuotasArr.push(grupo.nombre);
      }
    }
    setFaltanCuotas(faltanCuotasArr);
  };

  useEffect(() => {
    checkMissingCuotas();
  }, [grupos.data]);

  const DEUDA = 3;
  const FALTAS = 4;

  const loading = (!cuotas.data || cuotas.isLoading || !grupos.data || grupos.isLoading || !alumnos.data || alumnos.isLoading || !grupos.data);

  const alumnosActivos = alumnos.data?.filter((a) => !a.inactivo);
  // Deudores 3 meses
  const deudores = alumnosActivos?.filter((a) => (a.cuotasAdeudadas?.n && a.cuotasAdeudadas.n >= DEUDA));
  // faltaron ultimas 4
  const faltadores = alumnosActivos?.filter((a) =>{
    const ultimasFaltasSeguidas = a.asistencia
      .sort((fa, fb) => dayjs(fb.dia)
        .diff(fa.dia)).slice(0, FALTAS)
      .filter((as) => !as.asistencia);
    if (ultimasFaltasSeguidas.length >= FALTAS) return true;
    return false;
  });
  // faltaron ultimas 4 y deben 3 cuotas
  const abandonadores = faltadores?.filter((a) => (a.cuotasAdeudadas?.n && a.cuotasAdeudadas.n >= DEUDA));

  const sinGrupo = alumnosActivos?.filter((a) => !a.grupo);

  const hayAlerta = sinGrupo?.length || abandonadores?.length || faltadores?.length || deudores?.length || faltanCuotas?.length;

  let qty = 0;
  if (deudores?.length) qty += 1;
  if (faltadores?.length) qty += 1;
  if (abandonadores?.length) qty += 1;
  if (sinGrupo?.length) qty += 1;
  if (faltanCuotas?.length) qty += 1;

  return (
    {
      deudores,
      faltadores,
      abandonadores,
      sinGrupo,
      faltanCuotas,
      hayAlerta,
      loading,
      qty,
    }
  );
}
